export const contents = {
    'login': {
        'dari': {
            'Login': 'ورود به سیستم',
            'Please enter your credentials to continue': 'برای ادامه معلومات هویتی خود را وارد نمایید',
            'Forgot Password?': 'رمز عبور را فراموش کرده اید؟',
            'OTP Verification': 'تایید OTP',
            'Enter the code sent to {{email_address}}': 'لطفاً کد ارسال شده به ایمیل آدرس {{email_address}} را وارد کنید',
            'Verify': 'تایید نمایید',
            'Didn’t receive OTP?': 'رمز یک‌بار مصرف را دریافت نکردید؟',
            'Welcome to ZoodPay Admin Panel': 'به صفحه مدیریت سیستم زودپی خوش آمدید',
            'OTP has been sent to {{email_address}}': 'رمز عبور یک بار مصرف به ایمیل {{email_address}} ارسال شد',
            "Back": "بازگشت",
            "Resend":"دوباره بفرست",
            "Resend in {{minutes}}:{{seconds}}": "ارسال مجدد در {{minutes}}:{{seconds}}",
            "Resend limit exceeded": "محدودیت ارسال مجدد تمام شد",
        },
        'pashto': {
            "Login": "سیستم ته داخلېدل (لوګېن)",
            "Please enter your credentials to continue": "د دوام لپاره خپل هویتي معلومات د ننه کړئ",
            "Forgot Password?": 'پټ نوم مو هېر شوی؟',
            "OTP Verification": "د یو ځل کارېدونکي پسورډ تاییدول",
            "Enter the code sent to {{email_address}}": "دغه {{email_address}} برېښنالیک ته لېږل شوی کود د ننه کړئ",
            "Verify": "تایید یې کړئ",
            "Didn’t receive OTP?": 'ایا یوځل کاریدونکی پټ نوم مو ترلاسه نه کړ؟',
            "Welcome to ZoodPay Admin Panel": "د زود پې مدیریتي پنل ته ښه راغلاست",
            'OTP has been sent to {{email_address}}': "یو ځل کارېدو وړ پسورډ {{email_address}} برېښنالیک ته ولېږل شو",
            "Back": ' شاته ګرځېدل',
            "Resend":"بیا ولیږه",
            "Resend in {{minutes}}:{{seconds}}": "په {{minutes}}:{{seconds}} کې بیا ولیږئ",
            "Resend limit exceeded": "د بیا لیږلو حد تیر شو",
        },
        'uzbeki': {
            "Login": "سیستمگه کیریش",
            "Please enter your credentials to continue": "التماس دوام بیریش اوچون  کیملیک معلوماتینگیزنی کیریتینگ",
            "Forgot Password?": 'پسورد (اوتیش سوز)نی اونوتیب قویگن میز سیز؟',
            "OTP Verification": "بیر مرته‌لیک پسوردنی تیکشیریش",
            "Enter the code sent to {{email_address}}": "التماس ایمیل آدرسگه یوباریلگن کدنی {{email_address}} کیریتینگ",
            "Verify": "تصدیقلنگ",
            "Didn’t receive OTP?": 'OTPنی آلمه‌گنمیسیز؟',
            "Welcome to ZoodPay Admin Panel": "زودپی باشقریش پنلیگه خوش کیلیب سیز",
            'OTP has been sent to {{email_address}}': 'ایمیل گه بیر مرته مصرف بوله دیگن رمز  {{email_address}}  یوباریلدی',
            "Back": "قیتیش",
            "Resend":"قیته یوباریش",

        }
    },
    'Forgot password': {
        'dari': {
            "Forgot Password": "از یاد بردن رمز عبور",
            "Send Link": 'ارسال لینک',
            "Set New Password": "ایجاد رمز عبور جدید",
            "Please set a new password to regain access to your account": "برای دسترسی به حساب خود لطفاً یک رمز عبور جدید تعریف کنید",
            "Reset": "تنظیم دوباره",
            "Password should contain:": "رمز عبور باید دارای کرکترهای ذیل باشد:",
            "6 Characters length": "6کرکتر باشد",
            "1 Special character (e.g. !@#$%^&*)": "1کرکتر خاص (مانند: !@#$)",
            "1 Number": "1عدد",
            "Confirm New Password": "تایید رمز عبور جدید",
            "Password Updated!": "رمز عبور تجدید شد",
            "Your password has been successfully reset. Click below to login": "رمز عبور تان با موفقیت تجدید شد، برای ورد روی گزینه زیر  کلیک نمایید",
            'Login': 'ورود به سیستم',

        },
        'pashto': {
            "Forgot Password": "پسورډ مو هېر شوی",
            "Send Link": 'د لېنک لېږل',
            "Back": "بېرته شاته ګرځېدل",
            "Set New Password": "د نوي پسورډ جوړول",
            "Please set a new password to regain access to your account": "خپل حساب ته د ننوتلو لپاره هیله ده یو نوی پسورډ جوړ کړئ",
            "Reset": "دوهم ځلي تنظیم",
            "Password should contain:": "پسورډ باید لاندې موارد ولري:",
            "6 Characters length": "6کرکټره ولري",
            "1 Special character (e.g. !@#$%^&*)": "1ځانګړی کرکټر  (لکه: !@#$)",
            "1 Number": "۱ عدد",
            "Confirm New Password": "د نوي پسورډ تاییدول",
            "Password Updated!": "پسورډ نوی کړل شو",
            "Your password has been successfully reset. Click below to login": "ستاسو پسورډ په بریالیتوب سره نوی کړل شو. د ننه کېدو لپاره لاندې کلېک وکړئ",
            "Login": "سیستم ته داخلېدل (لوګېن)",
        },
        'uzbeki': {
            "Forgot Password": "پسوردینگیز  ایسدن چیقدیمی",
            "Send Link": 'لینکنی یوباریش',
            "Back": "قیتیش",
            "Set New Password": "ینگی پسورد یره‌تیش",
            "Please set a new password to regain access to your account": "حسابینگیزگه ایریشیش اوچون التماس ینگی بیر پسورد تعریف قیلینگ",
            "Reset": "ینه سازلنگ",
            "Password should contain:": "پسورد قوییده‌گی کرکترلر بولیشی کیره‌ک:",
            "6 Characters length": "6کرکتر بولسین",
            "1 Special character (e.g. !@#$%^&*)": "1خاص کرکتر (دیک: !@#$)",
            "1 Number": "1عدد",
            "Confirm New Password": "ینگی پسوردنی تصدیقلش",
            "Password Updated!": "پسورد ینگیلندی",
            "Your password has been successfully reset. Click below to login": "پسوردینگیز موفقیت بیلن ینگیلندی، کیریش اوچون قوییده‌گی وریانتنی باسینگ",
            "Login": "سیستمگه کیریش",
        }
    }
}